import React from 'react';
import * as signalR from "@microsoft/signalr";

// Flick these when packing for electron
// const url = process.env.NODE_ENV === 'development' ? "http://localhost:54210/queuehub" : "/queuehub";
const url = "https://brumunddal-legesenter-client.azurewebsites.net/queuehub";
console.log('Queuehub url', url);

export const useHubConnection = () => {
  const hubConnection = React.useRef(new signalR.HubConnectionBuilder()
    .withUrl(url)
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Debug)
    .build());

  React.useEffect(() => {
    // Starts the SignalR connection
    console.log('Starting queuehub');
    hubConnection.current?.start().then(a => {
      console.log('hub connection started')
    }).catch(e => console.error('hub error', e));

    return () => {
      console.log('Stopping hub connection');
      hubConnection.current?.stop().catch(_ => {
        console.log('hub stopped');
      });
    }
  }, []);

  const subscribe = React.useCallback((topic: string, callback: any) => {
    hubConnection.current?.on(topic, (data) => {
      try {
        var json = JSON.parse(data);
        callback(json);
        ack(topic);
      } catch {
        callback(data);
      }
    });
  }, []);

  const ack = React.useCallback((topic: string) => {
    hubConnection.current?.send(topic + "Ack").catch(_ => { });
  }, []);

  return {
    subscribe
  }
}